module.exports = __webpack_public_path__ + "static/media/books.e9fe9c48.jpg";